{
  "addAddress": "Adresse hinzufügen",
  "addContactData": "Kontaktdaten hinzufügen",
  "additionalId": "Artikelnummer",
  "additionalStockInfos": "Zusätzliche Lagerinformationen",
  "additionalTax": "zzgl.{0} Umsatzsteuer",
  "addProducts": "Produkte hinzufügen",
  "addProductToCollection": "Produkt zur einer Sammlung hinzufügen",
  "addProductToComparison": "Produkt zum Produktvergleich hinzufügen",
  "addProductToQuote": "Produkt zur einer Anfrage hinzufügen",
  "address": {
    "addition": "Adresszusatz",
    "city": "Stadt",
    "clientNumber": "Mandantennummer",
    "companyName": "Name und Rechtsform",
    "country": "Land",
    "defaultBillingAddress": "Standard Rechnungsadresse",
    "defaultDeliveryAddress": "Standard Lieferadresse",
    "details": "Details",
    "email": "E-Mail",
    "phone": "Telefon",
    "postBox": "Postfach",
    "primaryAddress": "Hauptadresse",
    "street": "Straße",
    "url": "URL",
    "website": "Webseite",
    "zipCode": "PLZ",
    "zipCodeLong": "Postleitzahl"
  },
  "addresses": "Adressen",
  "addToCart": "In den Warenkorb",
  "archiveAll": "Alle archivieren",
  "availability": "Verfügbarkeit",
  "b2bCommerPowered": "Powered by ITscope B2B Commerce",
  "backToPlatform": "Zurück zu ITscope",
  "billingAddress": "Rechnungsadresse",
  "cancel": "Abbrechen",
  "cart": {
    "optimizationFailed": "Die Warenkorboptimierung ist fehlgeschlagen.",
    "optimizationUnavailable": "Die Warenkorboptimierung konnte nicht durchgeführt werden, weil mehr als 250 Objekte im Warenkorb sind.",
    "removeAll": "Warenkorb leeren",
    "removeAllError": "Warenkorb konnte nicht geleert werden",
    "removeAllSuccess": "Warenkorb wurde erfolgreich geleert"
  },
  "cartOutdated": {
    "description": "Die Bestellung konnte nicht abgesendet werden, weil der Warenkorb nicht mehr aktuell ist. Bitte laden Sie den Warenkorb neu und führen Sie die Bestellung erneut aus.",
    "title": "Warenkorb nicht mehr aktuell"
  },
  "cartPositionComment": "Positionsfreitext",
  "categories": "Kategorien",
  "changed": "Geändert",
  "changePassword": "Passwort ändern",
  "charger": {
    "charger": "Ladegerät enthalten",
    "chargerIncludedTooltip": "Ein Ladegerät ist im Lieferumfang enthalten.",
    "chargerNotIncludedHint": "Ladegeräte mit den folgenden Spezifikationen können mit diesem Produkt verwendet werden.",
    "chargerNotIncludedTooltip": "Ein Ladegerät ist nicht im Lieferumfang enthalten.",
    "noCharger": "Kein Ladegerät enthalten"
  },
  "checkEmail": "E-Mail prüfen",
  "checkoutExpiredDialog": {
    "buttonCaption": "Zurück zum Checkout",
    "description": "Ihre Bestellung wartet",
    "title": "Sind Sie noch da?"
  },
  "chooseAddress": "Adresse auswählen",
  "clientNumber": "Kundennummer",
  "closeErrorOrders": "Spalte mit fehlerhafte Bestellungen schließen",
  "closeFilter": "Filter schließen",
  "closeMessage": "Nachricht schließen",
  "closeQuoteActivity": "Aktivitäten schließen",
  "collapseAccessoryCategory": "Zubehörkategorie \"{0}\" einklappen",
  "collapseDescription": "Beschreibung \"{0}\" einklappen",
  "collection": {
    "addAttachment": "Anhang hinzufügen",
    "addCollection": "Neue Sammlung",
    "addedToCartFailure": "Sammlung konnte nicht zum Warenkorb hinzugefügt werden",
    "addedToCartPartialSuccess": "Einige Positionen konnten nicht zum Warenkorb hinzugefügt werden",
    "addedToCartSuccess": "Sammlung wurde zum Warenkorb hinzugefügt",
    "addProductToExistingCollection": "Produkt zur bestehender Sammlung hinzufügen:",
    "addProductToNewCollection": "oder neue Sammlung erstellen:",
    "addToCart": "In den Warenkorb",
    "assignee": "Zuständiger Mitarbeiter",
    "collections": "Sammlungen",
    "collectProduct": "Produkt sammeln",
    "data": "Daten",
    "deleteAction": "Sammlung löschen",
    "deleteDialog": "Sind Sie sicher, dass diese Sammlung entfernt werden soll?",
    "deletedMessage": "Sammlung wurde entfernt",
    "duplicate": "Duplizieren",
    "editTitle": "Titel der Sammlung ändern",
    "emailSent": "Die Sammlung wurde erfolgreich per E-Mail versendet.",
    "emptyCollection": "Keine Produkte vorhanden",
    "lastModified": "Zuletzt geändert",
    "noCollectionAvailable": "Keine Sammlung vorhanden",
    "productAlreadyInCollection": "Produkt bereits in Sammlung vorhanden",
    "sendEmail": "Per E-Mail teilen",
    "shareCollection": "Sammlung \"{0}\" per E-Mail teilen",
    "subject": "Betreff",
    "success": {
      "itemRemoved": "Produkt wurde gelöscht"
    }
  },
  "common": {
    "archive": "Archivieren",
    "archived": "Archiviert",
    "comment": "Kommentar",
    "commentPlaceholder": "Kommentar hinzufügen...",
    "comments": "Kommentare",
    "dearchive": "Dearchivieren",
    "error": {
      "changeQuantity": "Die Menge konnte nicht geändert werden",
      "removeItem": "Position konnte nicht gelöscht werden",
      "updateAssignee": "Der zuständige Mitarbeiter konnte nicht geändert werden",
      "updateComment": "Der Kommentar konnte nicht aktualisiert werden",
      "updateName": "Der Name konnte nicht aktualisiert werden"
    },
    "sellerComment": "Verkäuferkommentar"
  },
  "company": {
    "deleteEmployee": "Mitarbeiter entfernen",
    "employee": "Mitarbeiter",
    "employeeDeleted": "Mitarbeiter wurde entfernt",
    "employees": "Mitarbeiter"
  },
  "companyData": "Firmen Daten",
  "companyRegistration": "Für die angegebene E-Mail Adresse existiert noch keine Firma. Bitte füllen Sie das unterstehende Formular aus, um einen Zugang anzufragen.",
  "condition": {
    "B_STOCK": "B-Ware",
    "BUILD_TO_ORDER": "Build-to-Order",
    "BULK": "Bulk",
    "DEMONSTRATION_MODEL": "Vorführgerät",
    "FACTORY_REFURBISHED": "Factory-Refurbished",
    "NEW": "Neu",
    "NEWPULL": "Ersatzteil aus Neugerät",
    "NOT_FOR_RESALE": "Nicht für den Wiederverkauf",
    "REFURBISHED": "Refurbished",
    "RMA_WARE": "RMA-/Rücksendeware",
    "USED": "Gebrauchtware",
    "USEDPULL": "Ersatzteil aus Gebrauchtgerät"
  },
  "conditionTooltip": {
    "conditionLabel": "Zustand",
    "monthsWarranty": "Monate Garantie"
  },
  "contactData": {
    "contactData": "Kontaktdaten",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname"
  },
  "contactTitles": {
    "diverse": "Divers",
    "female": "Frau",
    "male": "Herr",
    "unspecified": "keine Angabe"
  },
  "continue": "Weiter",
  "copy": "Kopie",
  "coreData": "Stammdaten",
  "costs": "Kosten",
  "create": "Erstellen",
  "created": "Erstellt",
  "createdDate": "Erstellungsdatum",
  "cto": {
    "appleCtoFinder": "Apple CTO-Finder",
    "configure": "{0} konfigurieren",
    "customiseConfiguration": "Konfiguration anpassen",
    "foundProduct": "Gefundenes Produkt",
    "noProductFound": "Für diese Konfiguration konnte kein Produkt gefunden werden",
    "selectBaseModel": "Basismodell wählen",
    "selectedConfiguration": "Ausgewählte Konfiguration",
    "selectProductClass": "Apple Produktklasse wählen"
  },
  "customerOrderId": "Endkundenbestellreferenz",
  "datasheet": "Datenblatt",
  "datasheetError": "Datenblatt konnte nicht geladen werden",
  "datasheetManufacturer": "Hersteller-Datenblatt",
  "datasheetNotFound": "Kein Datenblatt für dieses Produkt verfügbar",
  "datasheetPdf": "Datenblatt (PDF)",
  "decline": "Ablehnen",
  "declineReason": "Ablehnungsgrund",
  "delete": "Löschen",
  "deleteAddress": "Adresse löschen",
  "deleteAddressDialog": "Sind Sie sicher, dass diese Adresse gelöscht werden soll?",
  "deleteContactData": "Kontaktdaten löschen",
  "deliveryTracking": {
    "deliveryTracking": "Lieferung verfolgen",
    "trackPackage": "Paket verfolgen"
  },
  "departments": {
    "Accounting": "Buchhaltung",
    "Extern": "Extern",
    "IT": "IT",
    "Management": "Geschäftsleitung",
    "Marketing": "Marketing",
    "Other": "Sonstige",
    "Purchasing": "Einkauf",
    "RegistrationPending": "Registrierung ausstehend",
    "Sales": "Vertrieb",
    "ServiceSupport": "Service/Support"
  },
  "discount": "- {0} Rabatt",
  "documentError": "Dokument konnte nicht geladen werden",
  "downloadAllOrderDocumentsAsPdf": "Alle Bestelldokumente als PDF herunterladen",
  "downloadOrderDocumentAsPdf": "Bestelldokument \"{0}\" als PDF herunterladen",
  "ean": "EAN",
  "editAddress": "Adresse bearbeiten",
  "editCollectionAssignee": "Zuständiger Mitarbeiter ändern",
  "editContactData": "Kontaktdaten bearbeiten",
  "ellipsis": "...",
  "emailAddress": "E-Mail-Adresse",
  "emailForRegistration": "Bitte geben Sie eine E-Mail Adresse an, mit der Sie sich registrieren möchten.",
  "emailRequestPriceHint": "Folgende Mail wird an den Shopbetreiber zur Überprüfung gesendet (dies ist nur eine Vorschau des Textes):",
  "emptyCart": "Keine Artikel im Warenkorb",
  "epeat": "EPEAT zertifiziert",
  "epeatTooltip": {
    "description1": "Internationales Umweltzeichen für IT-Produkte.",
    "description2": "Bewertet u. a. Energieeffizienz, Recyclingfähigkeit und Materialwahl.",
    "description3": "Stufen: Bronze, Silber, Gold – je höher, desto umweltfreundlicher.",
    "title": "EPEAT-Label"
  },
  "eprel": {
    "energyEfficiency": "Energieeffizienzlabel",
    "energyEfficiencyAndProductDatasheet": "Informationen zum Energieeffizienzlabel",
    "energyEfficiencyInformationSheet": "Datenblatt"
  },
  "error": {
    "addressCreated": "Die Adresse konnte nicht erstellt werden",
    "addressDeleted": "Die Adresse konnte nicht gelöscht werden",
    "addressesNotFound": "Adressen konnten nicht geladen werden",
    "addressPropertyInvalid": "Adressfeld {propertyName} ist ungültig.",
    "addressSaved": "Die Adresse konnte nicht gespeichert werden",
    "alreadyInvited": "Mitarbeiter {0} ist bereit eingeladen",
    "alreadyRegistered": "Mitarbeiter {0} ist bereits registriert",
    "cartNotFound": "Warenkorb konnte nicht geladen werden",
    "categoriesNotFound": "Kategorien konnten nicht geladen werden",
    "changePassword": "Beim Ändern des Passworts ist etwas schief gelaufen",
    "changeQuantity": "Die Anzahl im Warenkorb konnte nicht geändert werden",
    "collectionNotFound": "Sammlung konnte nicht geladen werden",
    "documentsNotFound": "Dokumente konnten nicht geladen werden",
    "emailAlreadyRegistered": "Diese E-Mail ist bereits registriert",
    "emptyField": "Das Feld {0} muss einen gültigen Wert haben",
    "essentialShopActivationRequested": "Beim Abschicken der Anfrage ist etwas schief gelaufen",
    "fileTooLarge": "Die Dateigröße ist zu groß",
    "genericError": "Etwas ist schief gelaufen",
    "identifiersNotFound": "Seriennummern konnten nicht geladen werden",
    "invalidCharacters": "Nur Buchstaben, Zahlen und die Zeichen - _ / . # + sowie runde und eckige Klammern sind erlaubt (min. 3 Zeichen)",
    "invalidEmail": "Ungültige E-Mail Adresse",
    "invalidEmails": "Folgende E-Mailadressen sind nicht zulässig: {0}",
    "invalidName": "Ungültiger Name",
    "invalidNegativeNumber": "Nur positive Zahlen erlaubt",
    "invalidNumber": "Ungültige Nummer",
    "invalidUrl": "Ungültige Url",
    "invalidWhitespace": "Keine führenden, nachgestellten oder mehrfachen aufeinanderfolgenden Leerzeichen erlaubt",
    "invitation": "Beim Abschicken der Einladung ist etwas schief gelaufen",
    "keywordTooShort": "Bitte geben Sie einen Suchbegriff mit mindestens 2 Zeichen ein",
    "mailBlacklisted": "Die Domain {0} ist nicht freigegeben. Wenden Sie sich an Ihren Portalbetreiber.",
    "noAdmin": "Sie benötigen Adminrechte, um Mitarbeiter einzuladen",
    "noConsent": "Der Einwilligung muss zugestimmt werden",
    "oldPassword": "Ungültiges aktuelles Password",
    "ordersNotFound": "Bestellungen konnten nicht geladen werden",
    "pageNotFound": "Seite nicht gefunden",
    "passwordNotAllowedChar": "Das Passwort enthält ein oder mehrere unzulässige Zeichen.",
    "passwordRepeat": "Die Werte im Passwortfeld stimmen nicht überein",
    "passwordRequirements": "Ihr Kennwort erfüllt nicht die aktuellen Kennwort-Anforderungen.",
    "positiveDigit": "Es muss sich um einen positiven Wert handeln",
    "productAdded": "Das Produkt konnte nicht dem Warenkorb hinzugefügt werden",
    "productAlreadyInComparison": "Das Produkt befindet sich bereits im Vergleich",
    "productComparisonMaxNumber": "Maximal 3 Produkte können verglichen werden",
    "productDeleted": "Das Produkt konnte nicht aus dem Warenkorb entfernt werden",
    "productNotAvailableBySupplier": "Dieser Lieferant bietet das Produkt nicht an.",
    "productNotFound": "Produkt konnte nicht geladen werden",
    "productRequest": "Beim Abschicken der Anfrage ist etwas schief gelaufen",
    "productTypeIncorrectForComparison": "Nur Produkte derselben Kategorie können miteinander verglichen werden",
    "quoteForbidden": "Dieses Angebot ist noch nicht aktiv.",
    "quoteNotFound": "Angebot konnte nicht geladen werden",
    "quotesNotFound": "Angebote konnten nicht geladen werden",
    "refresh": "Es wurden Änderungen von anderen Nutzern durchgeführt. Laden Sie die Seite neu.",
    "registration": "Beim Abschicken der Registrierung ist etwas schief gelaufen",
    "registrationTokenError": "Der Link zum Abschluss der Registrierung scheint fehlerhaft. Bitte fordern Sie einen neuen an.",
    "requiredField": "Pflichtfeld",
    "resetPassword": "Beim Zurücksetzen ist etwas schief gelaufen",
    "resetTokenError": "Der Link zum Zurücksetzen des Passworts ist nicht mehr gültig. Bitte fordern Sie einen neuen an.",
    "serverError": "Serverfehler",
    "shortPassword": "Muss mindestens 8 Zeichen lang sein",
    "startPage": "Startseite konnte nicht geladen werden",
    "timeout": "Die Anfrage hat die maximale Zeit überschritten",
    "tooManyRequests": "Zu viele Anfragen. Versuchen Sie es zu einen späteren Zeitpunkt nochmal.",
    "unknownError": "Bei der Anfrage ist ein unbekannter Fehler aufgetreten ({0}).",
    "unknownLoginError": "Beim Einloggen ist ein unbekannter Fehler aufgetreten.",
    "unsupportedMediaType": "Der Dateityp wird nicht unterstützt",
    "updateComment": "Der Freitext-Kommentar konnte nicht aktualisiert werden",
    "userDeactivated": "Der angegebene Nutzer ist deaktiviert, ein Login ist derzeit nicht möglich.",
    "validDigit": "Es muss sich um eine gültige ganze Zahl handeln",
    "wrongCredentials": "Ihre E-Mail Adresse oder das Passwort sind nicht korrekt."
  },
  "errorId": "Fehler-ID",
  "errorPageHeadline": "Etwas ist schief gelaufen.",
  "errorPageOops": "Ooops",
  "errorPageQuoteNotAvailableSorry": "Versuchen Sie es zu einem späteren Zeitpunkt nochmal.",
  "errorPageStart": "Zur Startseite",
  "essentialShopDeactivated": {
    "descriptionEnd": "Sprechen Sie mit Ihrem Partner um Zugriff zu erhalten.",
    "descriptionPoint1": "Die Historie Ihrer Angebote zu sehen",
    "descriptionPoint2": "Anfragen für Angebote direkt an Ihren Partner zu stellen",
    "descriptionPoint3": "Zugriff auf ein Sortiment von 50.000 IT Produkten mit Filter und Suche",
    "descriptionPoint4": "einfach und direkt bestellen",
    "descriptionStart": "Im Essential-Shop haben Sie die Möglichkeit:",
    "descriptionTitle": "Der Essential-Shop Ihres Partners ist derzeit deaktiviert.",
    "pageTitle": "Essential-Shop deaktiviert",
    "requestActivation": "Freischaltung anfragen",
    "requestActivationHint": "Bitte geben Sie Ihre E-Mail-Adresse an, damit sich Ihr Partner mit Ihnen in Verbindung setzen kann."
  },
  "excludingVatHint": "Alle Preise exkl.{0} USt.",
  "excludingVatShort": "exkl.{0} USt.",
  "expandAccessoryCategory": "Zubehörkategorie \"{0}\" ausklappen",
  "expandDescription": "Beschreibung \"{0}\" ausklappen",
  "featureAd": {
    "comparison": {
      "description": "Über die Produktseite können Sie Produkte zum Vergleich hinzufügen",
      "shortDescription": "Sie können ab sofort Produkte vergleichen.",
      "title": "Produktvergleich"
    },
    "descriptionEnd": "Wir werden benachrichtigt und erstellen für Sie im Portal ein direkt bestellbares Angebot.",
    "descriptionStart": "So fragen Sie gesammelte Produkte bei uns an:",
    "NEW": "NEU",
    "requestFunction": "Anfrage-Funktion",
    "step1": "'Anfrage erstellen' klicken",
    "step2": "Produkte hinzufügen",
    "step3": "Anfrage absenden",
    "tryItOut": "Ausprobieren"
  },
  "filter": {
    "filter": "Filter",
    "filters": "Filter",
    "noFiltersSelected": "Keine Filter ausgewählt",
    "productFilters": "Eigenschaften",
    "productType": "Produkttyp",
    "resetFilter": "Filter zurücksetzen"
  },
  "finishRegistration": "Registrierung abschließen",
  "forgotPassword": "Passwort vergessen?",
  "grading": {
    "A": "Wie neu",
    "B": "Sehr gut",
    "C": "Gut",
    "D": "Akzeptabel"
  },
  "hideCategories": "Kategorien ausblenden",
  "hideCategory": "Kategorie einklappen",
  "hidePassword": "Passwort verbergen",
  "impersonateMode": "Kundenansicht - Sie sind als B2B Betreiber bei {0} angemeldet",
  "impersonateModeEssentialShop": "Kundenansicht – Angemeldet als Shop-Betreiber",
  "includingVat": "inkl.{0} Umsatzsteuer",
  "includingVatHint": "Alle Preise inkl.{0} USt.",
  "includingVatShort": "inkl.{0} USt.",
  "invitationHint": "Hiermit können Sie weitere Kollegen in Ihr Portal einladen. Bitte tragen Sie E-Mailadressen ein, an welche die Einladungen verschickt werden sollen und trennen Sie diese mit einem Semikolon oder Leerzeichen.",
  "inviteColleagues": "Kollegen einladen",
  "languages": {
    "de": "Deutsch",
    "en": "Englisch",
    "es": "Spanisch",
    "fr": "Französisch",
    "it": "Italienisch",
    "nl": "Niederländisch",
    "pl": "Polnisch"
  },
  "legalInfo": "Impressum",
  "less": "weniger",
  "localization": "Lokalisierung",
  "login": "Login",
  "login_sso": "Mit Single Sign-On (SSO) anmelden",
  "loginQuotesPortal": "Login Angebotsportal",
  "manufacturerId": "Hersteller-Artikelnummer",
  "max": "Max.",
  "maxLength": "Maximale Zeichenlänge von {0} erreicht",
  "mobex360Info": "Sollte das mobex360 Guthaben nicht ausreichen, wird die Bestellung automatisch in Rechnung gestellt!",
  "mobexPaymentMethod": {
    "CREDIT": "Mit mobex360 Guthaben",
    "INVOICE": "Per Rechnung"
  },
  "more": "mehr",
  "moreInfoEpeatTooltip": "Weitere Informationen zum EPEAT-Label",
  "moreUppercase": "Mehr",
  "myCompany": "Meine Firma",
  "myProfile": "Mein Profil",
  "name": "Name",
  "newPassword": "Neues Passwort",
  "newPasswordRepeat": "Neues Passwort bestätigen",
  "no": "Nein",
  "noAppleProductsAvailable": "Keine Apple Produkte vorhanden",
  "noCategoriesFound": "Keine Kategorien vorhanden",
  "noCollectionsFound": "Keine Sammlungen vorhanden",
  "noDataAvailable": "Keine Daten verfügbar",
  "noEntries": "Keine Einträge vorhanden",
  "noImageAvailable": "Kein Bild vorhanden",
  "noItemsInQuote": "Dieses Angebot enthält keine Positionen",
  "noOrderDocumentsFound": "Keine Dokumente vorhanden",
  "noOrdersFound": "Keine Bestellungen vorhanden",
  "noProductsFound": "Keine Produkte gefunden",
  "noSupplier": "Keine Zuordnung",
  "nullPriceLabel": "-,--",
  "oldPassword": "Aktuelles Passwort",
  "onlyWholePositiveNumbers": "Nur positive ganze Zahlen erlaubt",
  "open": "Öffnen",
  "openCart": "Warenkorb öffnen",
  "openCategory": "Kategorie ausklappen",
  "openFilter": "Filter öffnen",
  "openMenu": "Menü öffnen",
  "openProductComparison": "Produktvergleich öffnen",
  "openProductPage": "Produktseite öffnen",
  "openTopiCheckout": "topi-Checkout öffnen",
  "optimizationStrategyType": {
    "MANUAL": "Manuell",
    "MINPRICE": "Bester Preis",
    "MINSUPPLIERS": "Minimale Quellen"
  },
  "order": {
    "addedToCartFailure": "Bestellung konnte nicht zum Warenkorb hinzugefügt werden",
    "addedToCartPartialSuccess": "Einige Positionen konnten nicht zum Warenkorb hinzugefügt werden",
    "addedToCartSuccess": "Bestellung wurde zum Warenkorb hinzugefügt",
    "customerOrderIdMissing": "Es muss eine Endkundenbestellreferenz angegeben werden.",
    "declineOrder": "Bestellung ablehnen",
    "deleteDialog": "Sind Sie sicher, dass diese Bestellung gelöscht werden soll?",
    "deleteLastItemDialog": "Achtung: Beim Löschen der letzten Bestellposition wird auch die komplette Bestellung gelöscht. Wollen Sie fortfahren?",
    "deleteOrder": "Bestellung löschen",
    "deleteOrderItem": "Bestellposition löschen",
    "details": "Bestellung",
    "documents": "Dokumente",
    "editAddressHint": "Änderungen an der Adresse betreffen nur diese Bestellung.",
    "exclTotalTax": "exkl.{0} USt. {1}",
    "goToOrder": "Weiter zur Bestellung",
    "inclTotalTax": "inkl.{0} USt. {1}",
    "inEuTotalTax": "zzgl.{0} USt. {1}",
    "moreInfosLabel": "Weitere Angaben",
    "netDiscount": "Zusätzlicher Rabatt",
    "noApprover": "Für diese Bestellung ist kein Freigabebearbeiter verfügbar. Bitte wenden Sie sich an Ihren Portalbetreiber.",
    "noOrderRightHint": "Sie haben keine Berechtigung, die Bestellung auszuführen.",
    "order": "Bestellung",
    "orderAlreadyBeingProcessed": "Bestellung wird bereits bearbeitet. Bitte warten Sie ein paar Minuten auf die Bearbeitung.",
    "orderDate": "Bestelldatum",
    "orderLimitApprovalHint": "Die folgenden Personen werden über Ihre Anfrage per E-Mail informiert. Sobald die Bestellfreigabe bestätigt oder abgelehnt wurde, erhalten Sie eine Benachrichtigung per E-Mail.",
    "orderLimitHint": "Die Bestellung im Wert von {0} hat Ihr aktuelles Bestelllimit von {1} überschritten. Bitte Bestellfreigabe anfragen.",
    "orderNotFound": "Bestellung konnte nicht geladen werden",
    "orderNumber": "Bestellnummer",
    "orderNumberDuplicate": "Die Bestellnummer {0} wurde bereits bei einer Bestellung verwendet. Bitte versuchen Sie es mit einer anderen Bestellnummer.",
    "orderNumberGeneratedAfterOrder": "Wird nach der Bestellung erzeugt",
    "orderNumberMissing": "Es muss eine Bestellnummer angegeben werden.",
    "orderNumbers": "Bestellnummern",
    "orderRequested": "Anfrage abgeschickt",
    "orders": "Bestellungen",
    "orderSent": "Ihre Bestellung wurde übermittelt und wird nun verarbeitet.",
    "orderTimeoutError": "Keine Bestellantwort erhalten. Bitte Seite neu laden.",
    "partialShipmentAllowed": "Teillieferung erlauben",
    "paymentMethodMissing": "Es muss eine Abrechnungsmethode angegeben werden.",
    "quantitySurcharge": "Mindermengenzuschlag",
    "requestOrder": "Anfragen",
    "selectAddressHint": "Nur von Ihnen angelegte Adressen sind verwendbar.",
    "sendOrder": "Kostenpflichtig bestellen",
    "shippingAddress": "Lieferadresse",
    "shippingCosts": "Versandkosten",
    "shippingCostsGross": "Versandkosten brutto",
    "shippingCostsNet": "Versandkosten netto",
    "subTotal": "Zwischensumme",
    "toOrder": "Bestellen",
    "toOrderFrom": "Bestellen bei {0}",
    "totalCostsGross": "Gesamtbetrag brutto",
    "totalCostsNet": "Gesamtbetrag netto"
  },
  "orderApproval": {
    "approvableOrders": "Freizugebende Bestellungen",
    "approvedInformation": "Bestellung wurde von {0} am {1} freigegeben.",
    "declinedInformation": "Bestellung wurde von {0} am {1} abgelehnt.",
    "orderDeclined": "Bestellung erfolgreich abgelehnt",
    "pendingInformation": "Für diese Bestellung wurde am {0} eine Bestellfreigabe von {1} bei folgenden Personen angefordert:",
    "pendingInformationApprover": "Für diese Bestellung wurde am {0} eine Bestellfreigabe an Sie übermittelt.",
    "pendingInformationRequester": "Sie haben am {0} eine Bestellfreigabe an folgenden Personen übermittelt:"
  },
  "orderBy": "Bestellung bei {0}",
  "ordered": "Bestellt",
  "orderLimits": {
    "activateOrderLimits": "Bestelllimits aktivieren",
    "default": "Standard",
    "defaultApprovers": "Standardfreigabebearbeiter",
    "defaultApproversEmpty": "Kein Standardfreigabebearbeiter ausgewählt",
    "defaultApproversUsed": "Standardfreigabebearbeiter werden verwendet",
    "defaultLimit": "Allgemeines Limit",
    "defaultLimitDescription": "Dieses Bestelllimit ist der Standardwert für alle Mitarbeiter und wird von spezifischen Bestelllimits für Mitarbeiter überschrieben.",
    "description": "Durch das Vergeben von Limits können Mitarbeiter nur noch bis zu einem festgelegten Wert bestellen. Bestellungen die diesen Wert überschreiten, müssen bei einem Kollegen mit Freigaberechten, angefragt werden.",
    "editOrderLimitUser": "Bestelllimit vom Benutzer \"{0}\" ändern",
    "editStandardApprovers": "Standardfreigabebearbeiter bearbeiten",
    "individual": "Individuell",
    "noEmployeeFound": "Keinen Mitarbeiter gefunden",
    "noEmployeesFound": "Keine Mitarbeiter vorhanden",
    "orderApproval": "Bestellfreigabe",
    "orderApprover": "Freigabebearbeiter",
    "orderLimit": "Bestelllimit",
    "orderRight": "Bestellrecht",
    "unlimited": "Unbegrenzt"
  },
  "orderOutdated": {
    "description": "Die Bestellung konnte nicht gesendet werden, da sie nicht mehr aktuell ist. Bitte laden Sie die Bestellung neu und führen Sie sie erneut aus.",
    "title": "Bestellung nicht mehr aktuell"
  },
  "orderStatus": {
    "ADVISED": "Im Versand",
    "ARRIVED": "Bestellung eingegangen",
    "ARRIVED_WARNING": "Angekommen mit Warnung",
    "BLOCKED": "Gesperrt",
    "BLOCKED_BYLIMIT": "Gesperrt",
    "CANCELED": "Storniert",
    "ERROR": "Fehler",
    "IN_TOPI_CHECKOUT": "Im topi-Checkout",
    "INVOICED": "Berechnet",
    "ORDERED_ELSEWHERE": "Anderweitig abgeschlossen",
    "PARTIALLY_ADVISED": "Teilweise im Versand",
    "PARTIALLY_INVOICED": "Teilweise berechnet",
    "PARTIALLY_PROCESSING": "Teilweise bestätigt",
    "PAYMENT_AWAITING": "Zahlung ausstehend",
    "PAYMENT_SUCCESSFUL": "Zahlung erfolgreich",
    "PENDING_TOPI_APPROVAL": "Genehmigung ausstehend",
    "PORTAL_APPROVAL_DENIED": "Abgelehnt",
    "PREPARING": "Ausstehend",
    "PROCESSING": "Auftrag bestätigt",
    "REJECTED": "Abgelehnt",
    "SENDING_ERROR": "Übertragungsfehler",
    "SENT": "Übertragen",
    "TOPI_DECLINED": "Von topi abgelehnt",
    "TOPI_EXPIRED": "topi-Angebot abgelaufen",
    "TRANSMITTING": "Wird gerade übertragen"
  },
  "partsList": "Stückliste",
  "password": "Passwort",
  "passwordRepeat": "Passwort wiederholen",
  "paymentMethod": "Zahlungsart",
  "PDF": "PDF",
  "per": "je",
  "personalData": "Persönliche Daten",
  "pleaseSelect": "Bitte auswählen...",
  "portal": "Portal",
  "portalPaused": "Portal pausiert",
  "portalPausedDescription": "Dieses Portal ist derzeit pausiert, ein Login ist deshalb nicht möglich. Bei Fragen wenden Sie sich bitte an Ihren Portalbetreiber.",
  "positions": "Keine Position | {n} Position | {n} Positionen",
  "price": {
    "graduatedPrices": "Staffelpreise",
    "manufacturerSuggestedRetailPrice": "UVP",
    "packaging": "Verpackungseinheiten",
    "packaging_contentUnit": "Inhaltseinheit:",
    "packaging_contentUnit_label": "Einheit des Artikels innerhalb einer Bestelleinheit (z.B. \"Stück\" in Bestelleinheit \"Packung\").",
    "packaging_intervalQuantity": "Mengenstaffel:",
    "packaging_intervalQuantity_label": "Zahl, die angibt, in welcher Staffelung der Artikel bestellt werden kann (in Bestelleinheiten).",
    "packaging_minQuantity": "Mindestbestellmenge:",
    "packaging_minQuantity_label": "Anzahl von Bestelleinheiten, die mindestens bestellt werden müssen.",
    "packaging_numberContentUnitPerOrderUnit": "Verpackungsmenge:",
    "packaging_numberContentUnitPerOrderUnit_label": "Anzahl der Inhaltseinheiten pro Bestelleinheit des Artikels.",
    "packaging_orderUnit": "Bestelleinheit:",
    "packaging_orderUnit_label": "Einheit, in der der Artikel bestellt werden kann; es können nur Vielfache der Artikeleinheit bestellt werden.",
    "packaging_priceQuantity": "Preismenge:",
    "packaging_priceQuantity_label": "Ein Vielfaches der Bestelleinheit, welche angibt, auf welche Menge sich die Preise beziehen.",
    "packaging_supplierPackingQuantity": "Lieferanten-VPE:",
    "packaging_supplierPackingQuantity_label": "Verpackungsmenge des Vorlieferanten (in Bestelleinheiten).",
    "price": "Preis",
    "priceBillingPeriod": "pro {0}",
    "priceBillingPeriodShort": "p. {0}",
    "priceOnRequest": "a.A.",
    "pricePurchase": "HEK",
    "priceSubscriptionPeriod": "{0} Laufzeit",
    "priceVatStar": "*",
    "startingAt": "ab {0}"
  },
  "priceRange": {
    "applyPriceRange": "Preisspanne anwenden",
    "fromPriceRange": "Ab {0} {1}",
    "fromToPriceRange": "{0} {2} - {1} {2}",
    "invalidPriceRange": "Ungültige Preisspanne",
    "priceRange": "Preisspanne",
    "priceRangeFrom": "Preisspanne ab",
    "priceRangeTo": "Preisspanne bis",
    "toPriceRange": "Bis {0} {1}"
  },
  "print": "Drucken",
  "privacy": "Datenschutz",
  "privacyConsent": "Ich bin einverstanden, dass meine Daten gemäß der Datenschutzerklärung verarbeitet werden.",
  "product": "Produkt",
  "productAccessories": "Zubehör",
  "productComparison": {
    "highlightDifferences": "Unterschiede hervorheben",
    "noData": "Zu den ausgewählten Produkten wurden keine vergleichbaren Daten gefunden",
    "noMobileVersion": "Der Produktvergleich ist in der mobilen Ansicht nicht verfügbar",
    "noProducts": "Keine Produkte im Vergleich",
    "pageTitle": "Produkte vergleichen",
    "removeProduct": "Produkt aus Vergleich entfernen"
  },
  "productDescription": "Beschreibung",
  "productId": "Produkt-ID",
  "productIdentifiers": "Produkt IDs",
  "productNoLongerAvailable": "Produkt nicht mehr vorhanden",
  "products": "Produkte",
  "productSort": {
    "AVAILABILITY": "Verfügbarkeit",
    "CALC_PRICE_ASC": "Preis aufsteigend",
    "CALC_PRICE_DESC": "Preis absteigend",
    "NAME_ASC": "Produktname aufsteigend",
    "NAME_DESC": "Produktname absteigend",
    "POPULARITY": "Beliebtheit",
    "RELEVANCE": "Relevanz",
    "STOCK": "Lagerbestand"
  },
  "productStockInfo": {
    "nextDelivery": "Nächster Liefertermin laut Distributor voraussichtlich am {0}.",
    "nextDeliveryB2B": "Voraussichtlicher Zulauftermin beim Vorlieferanten: {0}.",
    "noNextDelivery": "Es ist kein genauer Liefertermin bekannt.",
    "onStock": "{0} auf Lager",
    "onSupply": "{0} im Zulauf",
    "unavailableMessage": "Das Produkt ist nicht verfügbar."
  },
  "punchout": {
    "backToProcurement": "Zurück in Ihr System",
    "backToProcurementCaption": "Ohne Bestellung zurück in Ihr System | Eine Position in Ihr System übernehmen | {n} Positionen in Ihr System übernehmen",
    "table": {
      "position": "Pos",
      "price": "Einzelpreis",
      "quantity": "Menge",
      "sum": "Gesamtpreis",
      "title": "Bezeichnung"
    }
  },
  "quantityFrom": "Menge ab",
  "quoteOutdated": {
    "description": "Das Angebot konnte nicht gesendet werden, da es nicht mehr aktuell ist. Bitte laden Sie das Angebot neu und führen Sie die Bestellung erneut aus.",
    "title": "Angebot nicht mehr aktuell"
  },
  "quotePreview": "Sie befinden sich in der Angebotsvorschau",
  "quoteRegistration": {
    "description": "Durch eine Registrierung in Ihrem persönlichen Essential Shop erhalten Sie ...",
    "products": "Zugriff auf <b>50.000 IT Produkte</b>",
    "quoteDocument": "Einsicht aller relevanten <b>Angebotsdokumente</b>",
    "quoteHistory": "die <b>Angebotshistorie</b> mit allen bereits erhaltenen Angeboten",
    "quoteRequest": "die Möglichkeit <b>Anfragen</b> zu stellen"
  },
  "quoteRequest": {
    "cannotEditRequest": "Keine Änderung mehr möglich, die Anfrage wurde bereits verschickt.",
    "emptyRequest": "Keine Produkte vorhanden",
    "lineItemAdded": "Position wurde erfolgreich hinzugefügt",
    "notInAssortment": "Aktuell nicht im Sortiment",
    "requestAgain": "Erneut anfragen",
    "requestNotFound": "Anfrage konnte nicht gefunden werden",
    "sendRequest": "Anfragen",
    "sentQuoteRequest": "Anfrage wurde erfolgreich versendet",
    "textLineItemAdd": "Freitextposition hinzufügen",
    "textLineItemChangeError": "Freitextposition-Titel konnte nicht geändert werden"
  },
  "quotes": {
    "acceptQuote": "Angebot annehmen",
    "addProductToExistingQuote": "Produkt zur bestehender Anfrage hinzufügen:",
    "addProductToNewQuote": "oder neue Anfrage erstellen:",
    "author": "Ersteller",
    "createRequest": "Anfrage erstellen",
    "declineInformation": "Angebot wurde von {0} am {1} abgelehnt.",
    "declineQuote": "Angebot ablehnen",
    "declineQuoteDialog": "Möchten Sie das Angebot wirklich ablehnen?",
    "deleteDescription": "Sind Sie sicher, dass diese Anfrage gelöscht werden soll?",
    "deleteTitle": "Anfrage löschen",
    "deselectOptionalItem": "Optionale Position abwählen",
    "duplicateUserWarning": "Sie können dieses Angebot nicht annehmen, weil Ihre E-Mail Adresse bereits mit einer anderen Firma verknüpft wurde. Bitte wenden Sie sich an den Ersteller des Angebots.",
    "editTitle": "Titel der Anfrage ändern",
    "new": "Neu",
    "noLongerValid": "Dieses Angebot ist am \"{0}\" abgelaufen und nicht mehr gültig.",
    "noOptionalPosition": "Keine optionale Position",
    "noQuoteEmptySpace": "Noch kein Angebot vorhanden",
    "noQuoteRequestsFound": "Keine Anfragen vorhanden",
    "noQuotesFound": "Keine Angebote vorhanden",
    "quote": "Angebot",
    "quoteRequested": "Anfrage wurde erfolgreich erstellt",
    "quotes": "Angebote",
    "request": "Anfrage",
    "selectOptionalItem": "Optionale Position auswählen",
    "showActivity": "Aktivitäten anzeigen"
  },
  "quoteStatus": {
    "ACCEPTED": "Angenommen",
    "DRAFT": "Entwurf",
    "NEGOTIATION": "In Verhandlung",
    "REJECTED": "Abgelehnt",
    "REQUESTED": "Angefragt"
  },
  "readOnlyMode": "Sie befinden sich aktuell im Read-Only-Modus.",
  "realtimePrices": "Realtime-Preise",
  "realtimePricesLoaded": "Realtime-Preise geladen",
  "recipients": "Empfänger",
  "refresh": "Neuladen",
  "refreshPage": "Seite neuladen",
  "register": "Registrieren",
  "registerCompany": "Firma registrieren",
  "registration": "Registrieren",
  "registrationDisabled": "Registrierung deaktiviert",
  "registrationDisabledDescription": "Der Betreiber hat die Registrierung und das Einloggen in diesem Portal deaktiviert.",
  "registrationLinkSent": "Eine E-Mail mit dem Registrierungslink wurde an Ihre E-Mail Adresse geschickt. Bitte öffnen Sie den Link, um die Registrierung abzuschließen.",
  "registrationRequested": "Die Anfrage wurde an den Portalbetreiber übermittelt. Sie erhalten eine Benachrichtigung via Email, sobald die Anfrage bestätigt wurde.",
  "removeDialog": "Sind Sie sicher, dass dieser Mitarbeiter entfernt werden soll?",
  "removeProductFromCart": "Produkt aus Warenkorb entfernen",
  "removeProductFromCollection": "Produkt aus Sammlung entfernen",
  "removeProductFromQuoteRequest": "Produkt aus Anfrage entfernen",
  "requestPrice": "Preis anfragen",
  "requestRegistration": "Zugang anfragen",
  "resetPassword": "Passwort zurücksetzen",
  "rma": {
    "requested": "Rücksendungungsanfrage verschickt",
    "return": "Rücksendung",
    "returned": "zurückgesendet",
    "returnReason": "Rücksendegrund",
    "selectedPositions": "Ausgewählte Positionen",
    "selectPositions": "Bitte wählen Sie die Positionen für Ihre Rücksendung aus",
    "selectProductForReturn": "Produkt für die Rücksendung auswählen",
    "selectReturnReason": "Grund wählen"
  },
  "save": "Speichern",
  "saveAddress": "Adresse übernehmen",
  "search": "Suchen",
  "searchAll": "Alle durchsuchen",
  "searchResults": "Suche nach \"{0}\" in Produkte",
  "send": "Absenden",
  "sendInvitation": "Einladung verschicken",
  "serialNumbers": {
    "copyAll": "Alle Kopieren",
    "serialNumbers": "Seriennummern",
    "serialNumbersCopied": "Serienummern in die Zwischenablage kopiert"
  },
  "serverOffline": {
    "description": "Das Portal ist aktuell wegen Wartungsarbeiten nicht verfügbar. Versuchen Sie es später erneut.",
    "title": "Portal nicht verfügbar"
  },
  "shippingCostsShort": "Versand",
  "shoppingCart": "Warenkorb",
  "shortUrl": {
    "enterZipCode": "Zum Öffnen des Angebots bitte die Postleitzahl Ihrer Adresse eingeben:",
    "enterZipCodeTitle": "Postleitzahl eingeben",
    "error": "Oops! Dieser Link ist nicht gültig!",
    "wrongZipCode": "Die eingebene Postleitzahl ist ungültig!"
  },
  "showCategories": "Kategorien anzeigen",
  "showErrorOrders": "Zeige alle Bestellungen mit einem Fehler-Status",
  "showPassword": "Passwort anzeigen",
  "signIn": "Einloggen",
  "signOut": "Ausloggen",
  "sortBy": "Sortieren nach",
  "sortbyAsc": "Aufsteigend nach \"{0}\" sortieren",
  "sortByDesc": "Absteigend nach \"{0}\" sortieren",
  "sources": "Bezugsquellen",
  "status": "Status",
  "stock": "Lager",
  "stockStatus": {
    "Available": "verfügbar",
    "NotAvailable": "nicht verfügbar",
    "OnOrder": "auftragsbezogen",
    "OnStock": "auf Lager",
    "Ordered": "im Zulauf",
    "Unknown": "unbekannt",
    "Warehouse": "im Außenlager"
  },
  "stockStatusDescription": "Lagerstatus ist \"{0}\"",
  "subsidiaryMode": "Kundenansicht - Sie sind bei {0} angemeldet",
  "success": {
    "addedToCollection": "Produkt erfolgreich zur Sammlung hinzugefügt",
    "addedToCollectionLink": "Produkt erfolgreich zur Sammlung \"{0}\" hinzugefügt >>",
    "addedToComparison": "Produkt wurde zum Vergleich hinzugefügt",
    "addedToQuote": "Produkt wurde erfolgreich zur Anfrage hinzugefügt.",
    "addedToQuoteLink": "Produkt wurde erfolgreich zur Anfrage \"{0}\" hinzugefügt. >>",
    "addressCreated": "Adresse wurde erstellt",
    "addressDeleted": "Adresse wurde gelöscht",
    "addressSaved": "Adresse wurde gespeichert",
    "cartRefreshed": "Warenkorb aktualisiert",
    "changeLanguage": "Sprache geändert",
    "changePassword": "Passwort erfolgreich geändert",
    "essentialShopActivationRequested": "Freischaltungsanfrage wurde abgeschickt",
    "invitationSent": "Einladung erfolgreich verschickt",
    "orderArchived": "Bestellung archiviert",
    "orderDearchived": "Bestellung dearchiviert",
    "productAdded": "Produkt wurde zum Warenkorb hinzugefügt",
    "productDeleted": "Produkt wurde aus dem Warenkorb entfernt",
    "productRequested": "Anfrage zum Produkt gesendet",
    "quoteArchived": "Angebot archiviert",
    "quoteDearchived": "Angebot dearchiviert",
    "registrationComplete": "Registrierung erfolgreich",
    "removedFromComparison": "Produkt wurde vom Vergleich entfernt",
    "resetPassword": "Es wurde eine E-Mail an \"{0}\" versendet, sofern ein aktives Nutzerkonto besteht."
  },
  "supplier": "Lieferant",
  "supplierPid": "Distributor Nr.",
  "switchSubsidiary": "Firma wechseln",
  "switchSubsidiaryHint": " Sie können sich in andere Firmen einloggen.",
  "technicalData": "Technische Daten",
  "terms": "AGB",
  "time": {
    "day": "Tag",
    "hour": "Stunde",
    "minute": "Minute",
    "month": "Monat",
    "year": "Jahr"
  },
  "title": "Titel",
  "to": "bis",
  "today": "Heute",
  "topiExpiredHint": "Das Angebot bei topi ist leider abgelaufen. Bitte legen Sie die Produkte über das Drei-Punkte-Menü erneut in den Warenkorb und klicken Sie dann auf ‚Weiter zur Mietkonfiguration'.",
  "transactionType": {
    "DELIVERY": "Lieferschein",
    "INVOICE": "Proforma Rechnung",
    "ORDER": "Bestellung",
    "ORDERSTATUS": "Bestellantwort",
    "PAYMENT": "Bezahlvorgang"
  },
  "unknown": "unbekannt",
  "updated": "Aktualisiert",
  "user": {
    "avatar": "Avatar",
    "company": "Firma",
    "contactTitle": "Anrede",
    "department": "Abteilung",
    "email": "E-Mail",
    "firstName": "Vorname",
    "language": "Sprache",
    "lastName": "Nachname",
    "permissions": {
      "changeSubsidiary": "Firma wechseln",
      "changeSubsidiaryDescription": "Legt fest, ob der Nutzer sich in verwandte Firmen einloggen darf.",
      "permissions": "Nutzerberechtigungen",
      "shopAdmin": "Admin",
      "shopAdminDescription": "Als Admin erhält der Nutzer die Befugnis, die Rechte, Kontaktdaten, Bestelllimits sowie Freigaben anderer Mitarbeiter zu bearbeiten. Zusätzlich kann der Admin-Nutzer neue Kollegen direkt in das Portal einladen.",
      "submitOrder": "Bestellen",
      "submitOrderDescription": "Bestimmen Sie, ob der Nutzer Bestellungen absenden darf."
    },
    "phone": "Telefonnummer",
    "phoneMobile": "Mobiltelefonnummer",
    "settings": {
      "allowTracking": "User Experience verbessern",
      "allowTrackingDescription": "Nehmen Sie am Optimierungsprogramm für eine bessere Benutzererfahrung teil.",
      "settings": "Nutzereinstellungen"
    }
  },
  "validDate": "Gültig bis",
  "viewToggle": {
    "ordersApprovals": "Bestellübersicht auf \"Freizugebendene Bestellungen\" umschalten",
    "ordersGrid": "Bestellübersicht auf Spaltenansicht umschalten",
    "ordersList": "Bestellübersicht auf Listenansicht umschalten",
    "productsCards": "Produktübersicht auf Kachelansicht umschalten",
    "productsList": "Produktübersicht auf Listenansicht umschalten",
    "quoteActivityChat": "Aktivitätenansicht auf Chat umschalten",
    "quoteActivityHistory": "Aktivitätenansicht auf Historie umschalten"
  },
  "windowTitle": {
    "Collection": "Sammlung",
    "CompanyOrderLimit": "Bestellfreigabe",
    "Login": "Loginseite",
    "Registration": "Registrierungsseite",
    "StartPage": "Startseite"
  },
  "writeSomething": "Schreiben Sie etwas...",
  "yes": "Ja",
  "yesterday": "Gestern"
}